import type { FC, HTMLAttributes, ReactNode } from "react";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
	hover?: boolean;
	children: ReactNode;
}

export const Card: FC<CardProps> = ({ hover = false, children, className = "", ...props }) => {
	return (
		<div
			className={`rounded-lg border border-line bg-surface shadow-sm ${
				hover ? "transition-shadow hover:shadow-md" : ""
			} ${className}`}
			{...props}
		>
			{children}
		</div>
	);
};

export interface CardHeaderProps extends HTMLAttributes<HTMLDivElement> {
	children: ReactNode;
}

export const CardHeader: FC<CardHeaderProps> = ({ children, className = "", ...props }) => {
	return (
		<div className={`border-b border-line px-6 py-4 ${className}`} {...props}>
			{children}
		</div>
	);
};

export interface CardBodyProps extends HTMLAttributes<HTMLDivElement> {
	children: ReactNode;
}

export const CardBody: FC<CardBodyProps> = ({ children, className = "", ...props }) => {
	return (
		<div className={`px-6 py-4 ${className}`} {...props}>
			{children}
		</div>
	);
};

export interface CardFooterProps extends HTMLAttributes<HTMLDivElement> {
	children: ReactNode;
}

export const CardFooter: FC<CardFooterProps> = ({ children, className = "", ...props }) => {
	return (
		<div className={`border-t border-line px-6 py-4 ${className}`} {...props}>
			{children}
		</div>
	);
};
